module.exports = "/assets/503fc2c1a2b47a5d349030256194efc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/NG.png
// module id = 1646
// module chunks = 0